export const BASE_URL = 'https://q-nomina.com.mx/quadrum-consulta-recibos-nomina-clientes-backend/';

